import { render, staticRenderFns } from "./dashboardSelector.vue?vue&type=template&id=121e915e&"
import script from "./dashboardSelector.vue?vue&type=script&lang=js&"
export * from "./dashboardSelector.vue?vue&type=script&lang=js&"
import style0 from "./dashboardSelector.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports